/* eslint-disable @typescript-eslint/no-explicit-any */
import { Box } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import React, { useState } from 'react';
import GetPayHistoryActionBox from '../ActionIcons/GetPayHistoryActionBox/GetPayHistoryActionBox';
import './tables_styles.css';
import EmployeeNamePic from '../EmployeeNamePic/EmployeeNamePic';
import PromotionsARModalController from '../../Modals/ActionRequiredModals/PromotionsARModal/PromotionsARModalController';
import _ from 'lodash';
import { useAppSelector } from '../../../infra/hooks';
import { actionRequiredService } from '../../../api/services/actionRequiredService';
import { useTranslate } from '../../../hooks';
import { arabicDataGrid, baseDateFormatting } from '../../helper';
import { DateField } from '../../../components';

interface Propval {
  trans: any;
}

const Promotions = ({ trans }: Propval) => {
  const [openModal, setOpenModal] = useState(false);
  const [canAct, setCanAct] = useState(false);
  const selector = useAppSelector((state) => state);

  const canTakeAction = (step_id: any) => {
    const step = step_id;

    actionRequiredService
      .userCanActOnStep(
        selector.authSlice.user_id,
        selector.authSlice.company_id,
        step,
        selector.authSlice.emp_id,
      )
      .then((response) => {
        setCanAct(response);
      })
      .catch(() => {
        setCanAct(false);
      });
  };

  //main state for handling data
  const [fullData, setFullData] = useState(null);
  const [currentPromotionHistory, setCurrentPromotionHistory] = useState([]);

  const getDepartmentPromotions = (id: any, cId: any) => {
    actionRequiredService
      .getDepartmentPromotions(id, cId)
      .then((result: any) => {
        if (result?.response == 'success') {
          setCurrentPromotionHistory(result?.data);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handlePromotionsView = (pro: any) => {
    getDepartmentPromotions(pro.emp_id, pro.company_id);

    setFullData(pro);
    canTakeAction(pro.step.id);
  };
  const storedARData = useAppSelector(
    (state) => state.actionRequiredSlice.actionRequiredData,
  );
  
  const tableColumns: any = [
    {
      field: 'empId',
      headerName: trans('Emp Id'),
      width: 200,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'header',
      height: 70,
    },
    {
      field: 'empName',
      headerName: trans('Emp Name'),

      flex: 1,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'header',
      height: 70,
      renderCell: (params: any) => {
        return (
          <EmployeeNamePic
            name={params.row.name}
            picture={params.row.profilePic}
          />
        );
      },
    },
    {
      field: 'promotionFrom',
      headerName: trans('Promotion From'),
      width: 200,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'header',
      height: 70,
    },
    {
      field: 'promotionTo',
      headerName: trans('Promotion To'),
      width: 200,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'header',
      height: 70,
    },

    {
      field: 'promotionDate',
      headerName: trans('Promotion Date'),
      width: 200,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'header',
      height: 70,
      renderCell: (params: any) => (
        <DateField
          value={params?.row?.promotionDate}
          format={baseDateFormatting}
        />
      ),
    },

    {
      field: 'action',
      flex: 1,
      headerName: trans('Action'),
      headerClassName: 'header',
      headerAlign: 'center',
      align: 'center',
      renderCell: (params: any) => {
        return (
          <GetPayHistoryActionBox
            onView={() => {
              handlePromotionsView(params?.row?.fullData);
              setOpenModal(true);
            }}
          />
        );
      },

      width: 200,
      height: 70,
    },
  ];

  const row_data = _.map(storedARData, (pro: any) => {
    return {
      id: pro.staff_id,
      empId: `#${pro.staff_id}`,
      name: pro.first_name + ' ' + pro.last_name,
      profilePic: pro.profile_pic,
      promotionFrom: pro.prev_designation,
      promotionTo: pro.current_designation,
      promotionDate: pro.promotion_date,
      fullData: pro,
    };
  });

  const { isRTL } = useTranslate();

  return (
    <>
      <Box
        className="ar_table"
        sx={{
          '& .header': {
            backgroundColor: '#F5F5F5',
          },

          width: '100%',
          marginTop: '2em',
        }}
      >
        <DataGrid
          sx={{
            color: '#081735',
            font: 'normal normal normal 14px/24px Lato;',
          }}
          autoHeight
          disableExtendRowFullWidth
          localeText={isRTL ? arabicDataGrid : undefined}
          disableSelectionOnClick
          disableColumnMenu
          disableColumnFilter
          rows={row_data}
          columns={tableColumns}
          componentsProps={{
            pagination: {
              labelRowsPerPage: trans('Rows per page'),
            },
          }}
        />
      </Box>
      {openModal && (
        <PromotionsARModalController
          closeModal={() => setOpenModal(false)}
          isModalOpen={openModal}
          promotions_data={fullData}
          currentPromotionHistory={currentPromotionHistory}
          canAct={canAct}
        />
      )}
    </>
  );
};

export default Promotions;
